export default __webpack_public_path__ + "static/media/dashbaord_X_white.fd8ed13b.svg";